import { StrategyChat } from '../form/assets';

export const getDescriptionStrategyChat = (strategy) => {
  switch (strategy) {
    case StrategyChat.LINEAR:
      return 'LINEAR';
    case StrategyChat.FEWEST_CHAT:
      return 'MENOR NÚMERO DE CHATS ATIVOS';
    case StrategyChat.FEWEST_CHAT_CLOSED:
      return 'MENOR NÚMERO DE CHATS ENCERRADOS';
    case StrategyChat.RANDOM:
      return 'ALEATÓRIO';
    case StrategyChat.NOT_DISTRIBUTE:
      return 'NÃO DISTRIBUIR';
    default:
      return '';
  }
};
